import { mutateEnt } from "shared/utils/fields";
import { useMutation } from "react-query";
import { axiosinstance } from "shared/utils/api";
import { useQuery } from "react-query";
import { queryClient } from "index";

export const useMFADisable = () => {
  const { mutateAsync, isLoading } = useMutation(() =>
    mutateEnt({
      url: `/v1/mfa/disable`,
      method: "post",
    })
  );

  return [mutateAsync, { isLoading }];
};

export const useMFAEmailSendCode = () => {
  const { mutateAsync, isLoading } = useMutation(() =>
    mutateEnt({
      url: `/v1/mfa/email/sendcode`,
      method: "post",
    })
  );

  return [mutateAsync, { isLoading }];
};

export const useValidateMFAEmailCode = () => {
  const { mutateAsync, isLoading } = useMutation((payload) =>
    mutateEnt({
      url: `/v1/mfa/email/code/validate`,
      method: "post",
      payload: payload,
    })
  );

  return [mutateAsync, { isLoading }];
};

export const useValidateMFAAuthenticatorCode = () => {
  const { mutateAsync, isLoading } = useMutation((payload) =>
    mutateEnt({
      url: `/v1/mfa/app/code/validate`,
      method: "post",
      payload: payload,
    })
  );

  return [mutateAsync, { isLoading }];
};

export const useUnlinkMFACode = () => {
  const { mutateAsync, isLoading } = useMutation((payload) =>
    mutateEnt({
      url: `/v1/mfa/app/code/unlink`,
      method: "post",
      payload: { email: payload },
    })
  );

  return [mutateAsync, { isLoading }];
};
export const useEnableMFAEmail = () => {
  const { mutateAsync, isLoading } = useMutation(
    () =>
      mutateEnt({
        url: `/v1/mfa/email/enable`,
        method: "post",
      }),
    {
      onSuccess: (result, payload, context) => {
        queryClient.setQueryData(["me"], (old) => ({
          ...old,
          two_fa_type: "EMAIL",
          two_fa_enabled: true,
        }));
      },
    }
  );

  return [mutateAsync, { isLoading }];
};

export const useGetOPTQRCode = () => {
  const fetchQRCode = () =>
    axiosinstance.get(`/v1/mfa/otp/qrcode`).then(({ data }) => data);
  const { data, isLoading, error, refetch, isFetching } = useQuery(
    ["QRCode"],
    fetchQRCode
  );

  return [
    data?.qr_code,
    data?.qr_code_uri,
    { isLoading, error, refetch, isFetching },
  ];
};

export const useConfirmOTPCode = () => {
  const { mutateAsync, isLoading } = useMutation(
    (payload) =>
      mutateEnt({
        url: `/v1/mfa/otp/confirm/code`,
        method: "post",
        payload: payload,
      }),
    {
      onSuccess: (result, payload, context) => {
        queryClient.setQueryData(["me"], (old) => ({
          ...old,
          two_fa_type: "AUTHENTICATOR_APP",
          two_fa_enabled: true,
        }));
      },
    }
  );

  return [mutateAsync, { isLoading }];
};
